import { css } from '@emotion/react';
import { colors } from 'folio-design-tokens';

export const focusShadow = `0 0 0 2px ${colors.blue}`;

export const noFocus = css`
  box-shadow: none !important;
`;
